import React from 'react';

import { Box, Typography } from '@mui/material';

import type { Tuple } from '@clearverify/types';

import { TabItem, Tabs } from 'src/components/common';

export const ButtonGroupSection: React.FC = () => {
  const [currentTabKey, setCurrentTabKey] = React.useState<TabItem['key']>(tabs[1].key);

  return (
    <Box component="section">
      <Typography variant="h3">Button Group (Tabs)</Typography>

      <Box mt={2}>
        <Typography variant="h4">Uncontrolled</Typography>
        <Tabs tabs={tabs} containerProps={{ mt: 2 }} />
      </Box>

      <Box mt={2}>
        <Typography variant="h4">Controlled</Typography>
        <Tabs
          tabs={tabs}
          containerProps={{ mt: 2 }}
          currentTabKey={currentTabKey}
          onChange={setCurrentTabKey}
        />
      </Box>
    </Box>
  );
};

const tabs: Tuple<TabItem, 3> = [
  {
    key: 'tab1',
    label: 'First tab',
    component: <Box>First tab content</Box>,
  },
  {
    key: 'tab2',
    label: 'Second tab',
    component: <Box>Second tab content</Box>,
  },
  {
    key: 'tab3',
    label: 'Third tab',
    component: <Box>Third tab content</Box>,
  },
];
